// components/SliderLayout.tsx
import React, { useEffect, useRef, useState } from "react";
import type SliderType from "react-slick";
import SliderOrig from "react-slick";
import "./Styles.scss";
// import './SliderGallery.css'

const Slider = SliderOrig as unknown as React.ComponentType<any>;

interface NavItem {
	id: number;
	img: string;
	title: string;
	mainTitle?: string
	content?: any
}

interface SliderLayoutProps {
	nav: NavItem[];
	listTitle?: string[];
	children?: (params: {
		currentIndex: number;
		listTitle?: string[];
		sliderSingleRef: React.RefObject<SliderType>;
		settingsSingle: any;
		nav: NavItem[];
	}) => React.ReactNode;
}

const SliderLayout: React.FC<SliderLayoutProps> = ({nav, listTitle = [], children}) => {
	const middleIndex = Math.ceil(nav.length / 2) - 1;
	const [currentIndex, setCurrentIndex] = useState(middleIndex);
	const sliderSingleRef = useRef<SliderType | null>(null);
	const sliderNavRef = useRef<SliderType | null>(null);
	const [isTablet, setIsTablet] = useState(false);

	useEffect(() => {
		const checkWidth = () => {
		const w = window.innerWidth;
		setIsTablet(w >= 767 && w <= 992);
		};

		checkWidth(); // chạy lần đầu
		window.addEventListener("resize", checkWidth);

		return () => window.removeEventListener("resize", checkWidth);
	}, []);

	const navWithPadding = nav.length < 6 && isTablet ? [
      ...nav,
      ...Array(2).fill({
        id: -1,
		img: '',
        title: "",
        isDummy: true
      })
    ] : nav;

	useEffect(() => {
		sliderNavRef.current?.slickGoTo(middleIndex, true); // true = không animate
		sliderSingleRef.current?.slickGoTo(middleIndex); // true = không animate
	}, []);

	// useEffect(() => {
	// 	console.log(`currentIndex: ${currentIndex}`)
	// }, [currentIndex]);

	const handleNavClick = (index: number) => {
		sliderSingleRef.current?.slickGoTo(index);
		sliderNavRef.current?.slickGoTo(index);
		setCurrentIndex(index);
		// console.log(`handleNavClick → index: ${index}`)
  	};

	const settingsNav = {
		slidesToShow: 5,
		slidesToScroll: 1,
		dots: false,
		infinite: false,
		arrows: false,
		swipe: false,
		draggable: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					swipe: true,
					draggable: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: true, 
					centerPadding: "0px" ,
					dots: true,
				}
			},
			{
				breakpoint: 767,
				settings: {
					swipe: true,
					draggable: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					beforeChange: (current: number, next: number) => {
						// console.log("beforeChange → next:", next);
						sliderSingleRef.current?.slickGoTo(next);
						setCurrentIndex(next);
					},
				}
				
			}
			
		]
		
	};

	const settingsSingle = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		adaptiveHeight: true,
		infinite: false,
		speed: 400,
		swipe: false,
		draggable: false,
		cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
		// beforeChange: (_: number, next: number) => {
		// 	// sliderNavRef.current?.slickGoTo(next);
		// 	setCurrentIndex(next);
		// },

		beforeChange: (current: number, next: number) => {
			// console.log("beforeChange → next:", next);
			// sliderNavRef.current?.slickGoTo(next);
			// setCurrentIndex(next);
		},
		
		// beforeChange: (_: number, next: number) => {
		// 	if (isFirstRender.current) {
		// 	isFirstRender.current = false; // Bỏ qua lần đầu
		// 	return;
		// 	}
		// 	console.log("next:", next);
		// 	// setCurrentIndex(next);
		// },
	};

	return (
		<div className="slider-layout">
			{/* Nav Slider */}
			<div className="slider slider-nav">
				<Slider ref={sliderNavRef} {...settingsNav}>
					{navWithPadding.map((item, index) => (
						
						<div 
							key={`${item.id}-${index}`} 
							onClick={() => !item.isDummy && handleNavClick(index)}
							className={`nav-item ${item.isDummy ? "dummy-slide" : ""}`}
						>
							<div className='icon'>
								<div className={`${index===currentIndex ? 'bg-rotated':''}`}></div>
								{!item.isDummy && <img src={item.img} alt="img" />}
							</div>
							<h3 className="text">
								<span>
									{item.title.split(" ").map((word: string, idx: number) => (
										<div key={idx}>{word}</div>
									))}
									{/* {item.title} */}
								</span>
							</h3>
						</div>
										
					))}
				</Slider>
			</div>

			{/* Children render phần còn lại */}
			{children &&
				children({
					currentIndex,
					listTitle,
					sliderSingleRef,
					settingsSingle,
					nav,
				})}
		</div>
	);
};

export default SliderLayout;
